import { packagePaymentPost } from '../actions/creators/packages';
import * as actions from '../actions/types';

export const packagesMiddleware = ({ getState, dispatch }) => next => action => {
  next(action);
  post(action, getState, dispatch);
};

function post(action, getState, dispatch) {
  switch (action.type) {
    case actions.PACKAGE_PAYMENT_FORM_SUBMIT:
      return onPackagePaymentPost(getState, dispatch, action);
    default:
      return;
  }
}

function onPackagePaymentPost(getState, dispatch, action) {
  const state = getState();
  const { purchase } = state.packages;

  purchase.payment.method = 'credit-card';

  return dispatch(packagePaymentPost(purchase));
}